import { render, staticRenderFns } from "./payment-view.vue?vue&type=template&id=5cfb0d4c&"
import script from "./payment-view.js?vue&type=script&lang=js&"
export * from "./payment-view.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports